module.exports = __webpack_public_path__ + "img/icon-alertwarn.9aba7b03.svg";